import { styled, TextField } from '@mui/material'

const Wrapper = styled('div')(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden'
}))
const SpacingWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    marginLeft: theme.spacing(-1),
    width: `calc(100% + ${theme.spacing(2)})`,
    padding: `${theme.spacing(0.25)} 0`,
    zIndex: '1'
}))
const StudentsSection = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
}))
const StudentWrapper = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.background?.default,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    paddingRight: theme.spacing(1)
}))
const StudentDetails = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    width: theme.spacing(9.5),
    p: {
        width: '100%',
        fontSize: theme.spacing(1.8),
        fontWeight: '700',
        lineHeight: 1.2,
        marginTop: theme.spacing(1),
        wordWrap: 'break-word'
    }
}))
const Avatar = styled('div')(({ theme }) => ({
    fontWeight: 800,
    width: theme.spacing(7),
    aspectRatio: '1',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.35)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: theme.palette.background?.default
}))
const StudentGrades = styled('div')<{ lastActivity: boolean }>(({ theme, lastActivity }) => ({
    display: 'flex',
    width: `calc(100% - ${theme.spacing(9.5)})`,
    flexWrap: lastActivity ? 'wrap' : 'nowrap',
    gap: theme.spacing(1)
}))
const GradeWrapper = styled('div')<{ lastActivity: boolean }>(({ theme, lastActivity }) => ({
    flex: lastActivity ? 'none' : '1',
    width: lastActivity ? theme.spacing(12) : 'auto',
    marginRight: lastActivity ? theme.spacing(1) : 0,
    p: {
        fontSize: theme.spacing(1.6),
        lineHeight: 1.2,
        marginBottom: theme.spacing(0.5),
        span: {
            fontWeight: '700',
            marginRight: theme.spacing(0.5)
        }
    }
}))
const Grade = styled('div')<{ grade?: number; isDisabled?: boolean }>(({ theme, grade, isDisabled }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(10),
    minWidth: theme.spacing(10),
    backgroundColor: theme.palette.grey?.[200],
    border: `solid 1px ${theme.palette.grey?.[300]}`,
    borderRadius: theme.spacing(4),
    overflow: 'hidden',
    pointerEvents: 'none',
    opacity: isDisabled ? '0.5' : 'none',
    span: {
        flex: 1,
        height: '100%',
        fontSize: theme.spacing(1.6),
        lineHeight: 1.6,
        borderRadius: '50%',
        textAlign: 'center',
        color: theme.palette.secondary?.main,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        pointerEvents: 'auto',
        '&:nth-of-type(1)': {
            backgroundColor: grade === 1 ? '#F9B3BD' : 'transparent'
        },
        '&:nth-of-type(2)': {
            backgroundColor: grade === 2 ? '#FFEADD' : 'transparent'
        },
        '&:nth-of-type(3)': {
            backgroundColor: grade === 3 ? '#A7D692' : 'transparent'
        },
        '&:nth-of-type(4)': {
            backgroundColor: grade === 4 ? '#6CBE3E' : 'transparent'
        }
    }
}))
const ButtonsWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(0.5),
    gap: theme.spacing(1)
}))
const StudentCommentInputField = styled(TextField)<{ isDisabled: boolean; isSummaryPannel?: boolean }>(({ theme, isDisabled, isSummaryPannel }) => ({
    width: isSummaryPannel ? 'auto' : `calc(100% - ${theme.spacing(9.5)})`,
    fieldset: {
        border: `solid 1px ${theme.palette.grey?.[300]}`,
        color: theme.palette.secondary?.main,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        fontSize: theme.spacing(1.8),
        lineHeight: 1.2,
        cursor: isDisabled ? 'not-allowed' : 'auto'
    },
    cursor: isDisabled ? 'not-allowed' : 'auto',
    marginRight: theme.spacing(2)
}))

export {
    Avatar,
    ButtonsWrapper,
    Wrapper,
    StudentGrades,
    Grade,
    GradeWrapper,
    SpacingWrapper,
    StudentsSection,
    StudentWrapper,
    StudentCommentInputField,
    StudentDetails
}
